module.exports = {
  content: [
    './public/**/*.html',
    './src/**/*.{html,js,jsx,ts,tsx,vue}',
    './app/**/*.{js,jsx,ts,tsx,vue}',
    './pages/**/*.{js,jsx,ts,tsx,vue}',
    './components/**/*.{js,jsx,ts,tsx,vue}',
  ],
  theme: {
    screens: {
      sm: '576px',
      md: '768px',
      lg: '992px', // only for CORPORATE (DWL) context and header component.
      xl: '1280px',
      xxl: '1400px',
      tablet: '576px',
      desktop: '1280px',
    },
    spacing: {
      0: 'var(--spacing-0)',
      1: 'var(--spacing-1)',
      2: 'var(--spacing-2)',
      3: 'var(--spacing-3)',
      4: 'var(--spacing-4)',
      5: 'var(--spacing-5)',
      6: 'var(--spacing-6)',
      7: 'var(--spacing-7)',
    },
    fontFamily: {
      'text': ['var(--copytext-font-family)'],
      'text-bold': ['var(--copytext-font-family-bold)'],
      'text-medium': ['var(--copytext-font-family-medium)'],
      'head': ['var(--headline-font-family)'],
      'icon': ['Liebherr-Icons'],
      'button': ['var(--button-font-family)'],
      'form-text': ['var(--form-text-font-family)'],
      'form-label': ['var(--form-label-font-family)'],
    },
    fontSize: {
      'h1': [
        'var(--h1-font-size)',
        {
          lineHeight: 'calc(1em + 4px)',
        },
      ],
      'h2': [
        'var(--h2-font-size)',
        {
          lineHeight: 'calc(1em + 4px)',
        },
      ],
      'h3': [
        'var(--h3-font-size)',
        {
          lineHeight: 'calc(1em + 4px)',
        },
      ],
      'h4': [
        'var(--h4-font-size)',
        {
          lineHeight: 'calc(1em + 4px)',
        },
      ],
      'h5': [
        'var(--h5-font-size)',
        {
          lineHeight: 'calc(1em + 4px)',
        },
      ],
      'h6': [
        'var(--h6-font-size)',
        {
          lineHeight: 'calc(1em + 4px)',
        },
      ],
      'copy': 'var(--copytext-font-size)',
      'copy-small': 'var(--copytext-font-size-small)',
      'copy-smaller': 'var(--copytext-font-size-smaller)',
      'copy-extra-small': 'var(--copytext-font-size-extra-small)',
      'button': 'var(--button-font-size)',
      'form': 'var(--form-size-text)',
      'form-label': 'var(--form-size-label-text)',
      'form-placeholder': 'var(--form-size-placeholder-text)',
      'additional-info': 'var(--form-size-additional-info-text)',
    },
    colors: {
      'transparent': 'transparent',
      'base': 'var(--font-base-color)',
      'white': 'var(--color-white)',
      'black': 'var(--color-black)',
      'yellow': 'var(--color-yellow)',
      'blue': 'var(--color-blue)',
      'arctic-blue': 'var(--color-artic-blue)',
      'primary': 'var(--primary-color)',
      'primary-accent': 'var(--primary-color-accent)',
      'primary-background': 'var(--primary-color-background)',
      'secondary': 'var(--secondary-color)',
      'secondary-accent': 'var(--secondary-color-accent)',
      'warning': {
        'DEFAULT': 'var(--color-warning)',
        'light': 'var(--color-warning-light)',
        'light-300': 'var(--color-warning-light-300)',
      },
      'success': {
        'DEFAULT': 'var(--color-success)',
        'light': 'var(--color-success-light)',
        'light-300': 'var(--color-success-light-300)',
      },
      'alert': {
        dark: 'var(--color-alert-dark)',
      },
      'slate': {
        DEFAULT: 'var(--color-slate)',
        light: 'var(--color-slate-light)',
        dark: 'var(--color-slate-dark)',
      },
      'leaf': {
        DEFAULT: 'var(--color-leaf)',
        light: 'var(--color-leaf-light)',
        dark: 'var(--color-leaf-dark)',
      },
      'ruby': {
        DEFAULT: 'var(--color-ruby)',
        light: 'var(--color-ruby-light)',
        dark: 'var(--color-ruby-dark)',
      },
      'clay': {
        'DEFAULT': 'var(--color-clay)',
        'light': 'var(--color-clay-light)',
        'light-300': 'var(--color-clay-light-300)',
      },
      'terra': {
        DEFAULT: 'var(--color-terra)',
        light: 'var(--color-terra-light)',
        dark: 'var(--color-terra-dark)',
      },
      'burgundy': {
        dark: 'var(--color-burgundy-dark)',
        light: 'var(--color-burgundy-light)',
      },
      'copper': {
        DEFAULT: 'var(--color-copper)',
        light: 'var(--color-copper-light)',
        dark: 'var(--color-copper-dark)',
      },
      'coolgreen': {
        dark: 'var(--color-coolgreen-dark)',
      },
      'gray': {
        50: 'var(--color-steel-50)',
        100: 'var(--color-steel-100)',
        200: 'var(--color-steel-200)',
        300: 'var(--color-steel-300)',
        400: 'var(--color-steel-400)',
        500: 'var(--color-steel-500)',
        600: 'var(--color-steel-600)',
        700: 'var(--color-steel-700)',
        800: 'var(--color-steel-800)',
        900: 'var(--color-steel-900)',
      },
    },
    boxShadow: {
      'basic': 'var(--shadow-elevation-basic)',
      'basic-top': 'var(--shadow-elevation-basic-top)',
      'middle': 'var(--shadow-elevation-middle)',
      'pin': 'var(--shadow-elevation-pin)',
      'flyout': 'var(--shadow-elevation-flyout)',
      'flyout-top': 'var(--shadow-elevation-flyout-top)',
    },
    letterSpacing: {
      basic: 'var(--letter-spacing-basic)',
    },
    extend: {},
  },
  corePlugins: {
    animation: false,
    preflight: true,
  },
  plugins: [],
};
